const gigyaOrderConfirmation = {
    guestRegisterWrapper: $('#cdcGuestRegistration'),
    termsCheckbox:        $('#confirmation__terms'),
    termsWrapper:         $('.confirmation__terms-control'),
    gigyaTermsCheckbox:   null,
    gender:               {
        mr:    'm',
        mrs:   'f',
        blank: 'u'
    },

    load() {
        if (this.guestRegisterWrapper) {
            document.addEventListener('gigya-registration-login-after-screenload', gigyaOrderConfirmation.populateForm);
            document.addEventListener('gigya-registration-login-before-validation', gigyaOrderConfirmation.validate);
            document.addEventListener('gigya-registration-login-field-change', gigyaOrderConfirmation.validate);

            const params = {
                screenSet:   'ATA-RegistrationLogin',
                startScreen: 'gigya-register-screen',
                containerID: 'cdcGuestRegistration'
            };
            window.gigya.accounts.showScreenSet(params);
        }
        gigyaOrderConfirmation.registrationSuccessMessage();
    },

    populateForm() {
        gigyaOrderConfirmation.gigyaTermsCheckbox = $('.confirmation__create-password .gigya-terms-checkbox');

        gigyaOrderConfirmation.termsCheckbox.on('click', function () {
            gigyaOrderConfirmation.termsWrapper.removeClass('gigya-terms-error');
            $('.confirmation__create-password .gigya-terms-checkbox label').trigger('click');
        });

        gigyaOrderConfirmation.termsCheckbox.siblings('label').children('.confirmation__terms-content').html(
                gigyaOrderConfirmation.gigyaTermsCheckbox.find('.registration-nl__text:not(.d-none)').html()
        );

        gigyaOrderConfirmation.termsWrapper.css({visibility: 'visible'});

        const data = {
            gender:    gigyaOrderConfirmation.gender[gigyaOrderConfirmation.guestRegisterWrapper[0].dataset.title],
            firstName: gigyaOrderConfirmation.guestRegisterWrapper[0].dataset.firstName,
            lastName:  gigyaOrderConfirmation.guestRegisterWrapper[0].dataset.lastName,
            email:     gigyaOrderConfirmation.guestRegisterWrapper[0].dataset.email
        };

        const registerForm                                  = $('#gigya-register-form');
        registerForm[0].elements.email.value                = data.email;
        registerForm[0].elements['profile.firstName'].value = data.firstName;
        registerForm[0].elements['profile.lastName'].value  = data.lastName;
        registerForm[0].elements['profile.gender'].value    = data.gender;
    },

    validate() {
        setTimeout(() => {
            const termsError = $('.confirmation__create-password .gigya-terms-checkbox').find('.gigya-terms-error');
            if (termsError.length) {
                gigyaOrderConfirmation.termsWrapper.addClass('gigya-terms-error');
            } else {
                gigyaOrderConfirmation.termsWrapper.removeClass('gigya-terms-error');
            }
        });
    },

    registrationSuccessMessage() {
        // Show confirmation message for successful account creation
        const currentURl = new URL(window.location.href);
        currentURl.searchParams.get('register-confirmation');
        if (currentURl.searchParams.get('register-confirmation') === "true") {
            $('.confirmation__register-success').removeClass('d-none');
        }
    }
};

export default gigyaOrderConfirmation;
